export const SET_USER_LOGIN = 'SET_USER_LOGIN';

export const setUserLogin = ({ user, permission, permisionEntities, profiles } = {}) => ({
    type: SET_USER_LOGIN,
    payload: {
        user,
        permission,
        permisionEntities,
        profiles
    }
});
